import BaseModule from "@core/modules/base-module/base-module";
import Pattern from "@pj/components/pattern/pattern";

const faqFormLists=new BaseModule();
faqFormLists.name='faq-form-lists';
faqFormLists.revealOnScroll=false;
faqFormLists.init(that=> {
  const pattern=new Pattern();
  pattern.init(that.elements);
});
